import { NON_FATF_COUNTRIES, getCustomerCountryName } from '../../../services/countriesService';

interface SelectedCountriesSummaryProps {
  selectedCountries: string[];
  isNonFatfSelected: boolean;
}

function SelectedCountriesSummary({ selectedCountries, isNonFatfSelected }: SelectedCountriesSummaryProps): JSX.Element | null {
  const mergedCodes = new Set(selectedCountries);
  if (isNonFatfSelected) {
    Array.from(NON_FATF_COUNTRIES).forEach((code) => mergedCodes.add(code));
  }

  if (mergedCodes.size === 0) {
    return null;
  }

  const sorted = Array.from(mergedCodes).sort((a, b) =>
    getCustomerCountryName(a).localeCompare(getCustomerCountryName(b))
  );

  return (
    <div className="App-summary-card">
      <div className="App-alert-content">
        <div className="App-alert-icon">🌍</div>
        <div className="App-alert-text-container">
          <span className="App-alert-text">
            Selected Countries ({sorted.length})
          </span>
          <div className="App-customer-country-list">
            <div className="App-country-checkboxes">
              {sorted.map((code) => (
                <span key={code} className="App-country-readonly-item">
                  {getCustomerCountryName(code)}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelectedCountriesSummary;
